"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelImageVisibilityState = exports.CollectionModelImageVisibilityStateMutator = void 0;
var id_1 = require("../../../id");
var hidden_imageVisibility_1 = require("./hidden.imageVisibility");
function makeImageVisibilityState(tag, id) {
    switch (tag) {
        case 'hidden':
            return hidden_imageVisibility_1.CollectionModelHiddenImageVisibility.state(id);
        default:
            throw new Error("Unknown marker type: \"".concat(tag, "\""));
    }
}
var CollectionModelImageVisibilityStateMutator = /** @class */ (function () {
    function CollectionModelImageVisibilityStateMutator(state) {
        this.state = state;
    }
    CollectionModelImageVisibilityStateMutator.prototype.getState = function () {
        var collectionState = this.state.collection.state;
        var captureImageVisibilityKey = CollectionModelImageVisibilityState.captureImageVisibilityId(this.state.captureId);
        return collectionState.getFieldValue(captureImageVisibilityKey);
    };
    CollectionModelImageVisibilityStateMutator.prototype.setState = function (state) {
        var collectionState = this.state.collection.state;
        var captureImageVisibilityKey = CollectionModelImageVisibilityState.captureImageVisibilityId(this.state.captureId);
        collectionState.setFieldValue(captureImageVisibilityKey, state);
    };
    CollectionModelImageVisibilityStateMutator.prototype.create = function (tag, id) {
        if (id === void 0) { id = id_1.IkeId.generate(); }
        var state = makeImageVisibilityState(tag, id);
        return this.createWithState(state);
    };
    CollectionModelImageVisibilityStateMutator.prototype.clear = function () {
        this.state = null;
    };
    CollectionModelImageVisibilityStateMutator.prototype.createWithState = function (state) {
        var collectionState = this.state.collection.state;
        var captureId = this.state.captureId;
        var stateId = CollectionModelImageVisibilityState.imageVisibilityId(captureId);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error("Image Visibility \"".concat(stateId, "\" already exists"));
        }
        collectionState.setFieldValue(stateId, state);
        this.setState(state.id);
        return state.id;
    };
    return CollectionModelImageVisibilityStateMutator;
}());
exports.CollectionModelImageVisibilityStateMutator = CollectionModelImageVisibilityStateMutator;
var ID_PREFIX_IMAGE_VISIBILITY = 'iv';
var ID_PREFIX_CAPTURE_IMAGE_VISIBILITY = 'civ';
var CollectionModelImageVisibilityState = /** @class */ (function () {
    function CollectionModelImageVisibilityState(collection, captureId) {
        this.Mutator = new CollectionModelImageVisibilityStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.collection = collection;
        this.captureId = captureId;
    }
    CollectionModelImageVisibilityState.imageVisibilityId = function (captureId) {
        return "".concat(ID_PREFIX_IMAGE_VISIBILITY, ":").concat(captureId, ":image-visibility-hidden");
    };
    CollectionModelImageVisibilityState.captureImageVisibilityId = function (captureId) {
        return "".concat(ID_PREFIX_CAPTURE_IMAGE_VISIBILITY, ":").concat(captureId);
    };
    CollectionModelImageVisibilityState.getCaptureImageVisibilityId = function (key) {
        if (key.startsWith("".concat(ID_PREFIX_CAPTURE_IMAGE_VISIBILITY, ":"))) {
            return key.substr(3);
        }
        return null;
    };
    CollectionModelImageVisibilityState.prototype.hasImageVisibility = function () {
        return !!this.state;
    };
    CollectionModelImageVisibilityState.prototype.hideForExport = function () {
        if (!(this.hasImageVisibility())) {
            return false;
        }
        else {
            var visibility = this.getImageVisibility();
            switch (visibility.state.tag) {
                case 'hidden':
                    var hidden = this.getImageVisibility().hidden;
                    return Boolean(hidden);
                default:
                    return false;
            }
        }
    };
    CollectionModelImageVisibilityState.prototype.getImageVisibility = function () {
        var imageVisibility = this.imageVisibility;
        if (imageVisibility == null) {
            var imageVisibilityId = CollectionModelImageVisibilityState.imageVisibilityId(this.captureId);
            var imageVisibilityState = this.collection.state.getFieldValue(imageVisibilityId);
            if (imageVisibilityState == null) {
                //if we can't find a state with the current id, we recreate a new state with the same id, and query it again
                this.Mutator.create('hidden');
                imageVisibilityState = this.collection.state.getFieldValue(imageVisibilityId);
            }
            switch (imageVisibilityState.tag) {
                case 'hidden':
                    imageVisibility = new hidden_imageVisibility_1.CollectionModelHiddenImageVisibility(this, imageVisibilityId, this.captureId);
                    break;
                default:
                    throw new Error("Capture ".concat(this.captureId, ":Unknown visibility correction type: \"").concat(imageVisibilityState.tag, "\""));
            }
            this.imageVisibility = imageVisibility;
        }
        return imageVisibility;
    };
    CollectionModelImageVisibilityState.prototype.value = function () {
        return this.getImageVisibility();
    };
    Object.defineProperty(CollectionModelImageVisibilityState.prototype, "capture", {
        get: function () {
            return this.collection.state.getCapture(this.captureId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelImageVisibilityState.prototype, "state", {
        get: function () {
            return this.collection.state.getFieldValue(CollectionModelImageVisibilityState.captureImageVisibilityId(this.captureId));
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelImageVisibilityState;
}());
exports.CollectionModelImageVisibilityState = CollectionModelImageVisibilityState;
//# sourceMappingURL=imageVisibility.state.js.map